import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import {exportReport, organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from "react-notifications";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import {GreenButton} from "../common/ButtonsConstants";
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import * as CommonUtils from "../../util/CommonUtils";

const top = 50;
const left = 50;

const classes = (theme => ({

    paper: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    },
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
        marginTop: "40px",
    },
}));

class InterestedParties extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            organisation: null,
            orgId: "",
            regulators: "",
            staff: "",
            customers: "",
            investors: "",
            management: "",
            employees: "",
            environment: "",
            community: "",
            suppliers: "",
            other: "",
        };
        this.export = this.export.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    export() {
        exportReport('/organisation/export/INTERESTED_PARTIES');
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    regulators: response.regulators || '',
                    staff: response.staff || '',
                    customers: response.customers || '',
                    investors: response.investors || '',
                    management: response.management || '',
                    employees: response.employees || '',
                    environment: response.environment || '',
                    community: response.community || '',
                    suppliers: response.suppliers || '',
                    other: response.other || '',
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({ show: true });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        console.log("Submitted");
        const organisationDetailsRequest = Object.assign(this.state.organisation,
            {
                id: this.state.orgId,
                regulators: this.state.regulators,
                staff: this.state.staff,
                customers: this.state.customers,
                investors: this.state.investors,
                management: this.state.management,
                employees: this.state.employees,
                environment: this.state.environment,
                community: this.state.community,
                suppliers: this.state.suppliers,
                other: this.state.other,
            }
        );
        console.log(organisationDetailsRequest);
        saveOrUpdateOrganisationDetails(organisationDetailsRequest)
            .then(() => {
                NotificationManager.success('Success', 'The Interested Parties have been updated.', 5000);
                this.closeModal();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        const { classes } = this.props;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                INTERESTED PARTIES
            </Typography>
            {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>EXPORT</GreenButton>}
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <tr>
                            <th style={{ textAlign: 'left', paddingLeft: '16px' }}>INTERESTED PARTY</th>
                            <th style={{ textAlign: 'left', paddingLeft: '16px' }}>OVERVIEW OF THE STAKEHOLDER</th>
                        </tr>
                    </TableHead>
                    <TableBody>
                        <TableRow key='regulators'>
                            <TableCell component="td" scope="row">
                                Regulator(s)
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.regulators ? state.regulators : <b>&lt;Outline the regulators for the organisation&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='staff'>
                            <TableCell component="td" scope="row">
                                Staff
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.staff ? state.staff : <b>&lt;Overview of staff members&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='customers'>
                            <TableCell component="td" scope="row">
                                Customers
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.customers ? state.customers : <b>&lt;Overview of the major sponsors to the business&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='investors'>
                            <TableCell component="td" scope="row">
                                Investors/shareholder/owner
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.investors ? state.investors : <b>&lt;Overview of the Investors/shareholder/owner&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='management'>
                            <TableCell component="td" scope="row">
                                Management
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.management ? state.management : <b>&lt;Overview of Management&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='employees'>
                            <TableCell component="td" scope="row">
                                Employees
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.employees ? state.employees : <b>&lt;Overview of Employees&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='environment'>
                            <TableCell component="td" scope="row">
                                Biophysical environment
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.environment ? state.environment : <b>&lt;Overview of the Biophysical environment (i.e. effective use of water, sustainability of current patterns of energy use)&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='community'>
                            <TableCell component="td" scope="row">
                                Local community
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.community ? state.community : <b>&lt;Overview of the Local community&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='suppliers'>
                            <TableCell component="td" scope="row">
                                Suppliers
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.suppliers ? state.suppliers : <b>&lt;Overview of the Suppliers&gt;</b>}</TableCell>
                        </TableRow>
                        <TableRow key='other'>
                            <TableCell component="td" scope="row">
                                Government and other regulators
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>{state.other ? state.other : <b>&lt;Overview of Government and other regulators&gt;</b>}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={this.closeModal}
            >
                <div className={classes.paper}>
                    <Typography component="h2" variant="h5">Interested Parties</Typography>
                    <form onSubmit={this.handleSubmit} className={classes.form}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="regulators"
                            label="Regulator(s)"
                            name="regulators"
                            value={state.regulators}
                            autoFocus
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="staff"
                            label="Staff"
                            name="staff"
                            value={state.staff}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="customers"
                            label="Customers"
                            name="customers"
                            value={state.customers}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="investors"
                            label="Investors"
                            name="investors"
                            value={state.investors}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="management"
                            label="Management"
                            name="management"
                            value={state.management}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="employees"
                            label="Employees"
                            name="employees"
                            value={state.employees}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="environment"
                            label="Biophysical environment"
                            name="environment"
                            value={state.environment}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="community"
                            label="Local community"
                            name="community"
                            value={state.community}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="suppliers"
                            label="Suppliers"
                            name="suppliers"
                            value={state.suppliers}
                            onChange={ this.handleChange }
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="other"
                            label="Government and other regulators"
                            name="other"
                            value={state.other}
                            onChange={ this.handleChange }
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Submit
                        </Button>
                    </form>
                </div>
            </Modal>
            <Button
                onClick={this.showModal}
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                disabled={isAuditor}
            >
                Edit
            </Button>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(InterestedParties);